import { css } from '@emotion/react'
import { SelectedStatusRow } from '../containers/search-result'
import { StatusesState } from '../reducers/statuses'
import { OptionDropdown } from '../../../view/OptionDropdown'
import { OptionDropdownItem } from '../../../view/OptionDropdownItem'
import { useUser } from '../../../../contexts/AuthContext'
import { User } from '../../../../types'
import { statusSettingPath } from '@/lib/url'
import { colors, Divider } from 'plume-ui'

type Props = {
  selectedCompanyStatus: SelectedStatusRow | null
  setSelectedCompanyStatus: React.Dispatch<
    React.SetStateAction<SelectedStatusRow | null>
  >
  statuses: StatusesState['data']
  onSelectStatusBlank: (companyId: string, user: User) => void
  onSelectStatus: (
    id: string,
    companyId: string,
    name: string,
    user: User
  ) => void
}

export const CompanyStatusesOptionDropDown: React.FC<Props> = ({
  selectedCompanyStatus,
  setSelectedCompanyStatus,
  statuses,
  onSelectStatusBlank,
  onSelectStatus,
}) => {
  const user = useUser()

  const statusSettingLink = () => {
    window.open(statusSettingPath, '_blank')
  }

  return selectedCompanyStatus != null ? (
    <OptionDropdown
      _css={css`
        margin-top: 16px;
        max-height: 320px;
        overflow-y: auto;
        top: ${selectedCompanyStatus.target &&
        selectedCompanyStatus.target.getBoundingClientRect().top +
          window.pageYOffset +
          37}px;
        left: ${selectedCompanyStatus.target &&
        selectedCompanyStatus.target.getBoundingClientRect().left +
          window.pageXOffset}px;
      `}
      open={true}
      hideTopArrow
    >
      <OptionDropdownItem
        label="（空白）"
        condition={selectedCompanyStatus.selectedStatusName == null}
        idx={0}
        handleSet={() => {
          onSelectStatusBlank(selectedCompanyStatus.companyId, user)
          setSelectedCompanyStatus(null)
        }}
      />
      {statuses.map((s: { id: string; name: string; color: string }, idx) => (
        <OptionDropdownItem
          key={s.id}
          condition={s.name === selectedCompanyStatus.selectedStatusName} // TODO: id で突き合わせる
          idx={idx}
          handleSet={() => {
            onSelectStatus(s.id, selectedCompanyStatus.companyId, s.name, user)
            setSelectedCompanyStatus(null)
          }}
          label={s.name}
          _css={css`
            max-width: 320px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          `}
        />
      ))}
      <Divider
        css={css`
          margin: 4px 0;
        `}
      />
      <OptionDropdownItem
        condition={true}
        idx={0}
        handleSet={statusSettingLink}
        label={'ステータス項目を編集'}
        icon="icon-pen-fill"
        iconCss={css`
          color: ${colors.textLight};
        `}
      />
    </OptionDropdown>
  ) : null
}
